<template>
  <v-toolbar class="ml-4 limit wd-100" color="transparent">
    <v-toolbar-title style="font-size: 24px; font-weight: bold"
      >{{ this.projeto }} - Requisitos</v-toolbar-title
    >
    <modal-criar-requisito
      v-if="isDev"
      @requisito-criado="getRequisitos"
    ></modal-criar-requisito>
  </v-toolbar>

  <div class="ml-8">
    <v-checkbox
      v-model="isDraft"
      label="Mostrar apenas os rascunhos"
      color="primary"
      hide-details
    ></v-checkbox>
  </div>

  <v-table
    class="ma-8 mt-1 req--table elevation-1"
    style="background: transparent"
    fixed-header="true"
    density="comfortable"
  >
    <thead class="text-grey">
      <tr>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Requisito
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Descrição
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Tipo
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="rounded-te-lg text-left text-grey"
        >
          Observação
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Ações
        </th>
      </tr>
    </thead>
    <div class="split"></div>
    <tbody>
      <tr v-for="item in requisitosFiltrados" :key="item">
        <td style="border-left: thin solid #efefef" class="text-left">
          <router-link
            :to="
              '/projects/' + this.idProjeto + '/Requisitos/' + item.id_requisito
            "
            ><p class="text-decoration-underline">
              {{ item.identificacao }}
            </p></router-link
          >
        </td>
        <td style="border-left: thin solid #efefef" class="text-left">
          {{ item.descricao }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-left">
          {{ converterEnumParaTexto(item.tipo_requisito) }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-left">
          {{ item.observacao }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-left">
          <v-row class="align-center">
            <v-col cols="2">
              <RouterLink
                :to="
                  '/projects/' +
                  this.idProjeto +
                  '/Requisitos/' +
                  item.id_requisito
                "
              >
                <v-icon
                  size="large"
                  color="green-darken-2"
                  icon="mdi-eye-arrow-right-outline"
                ></v-icon>
              </RouterLink>
            </v-col>

            <v-col cols="2">
              <modal-editar-requisito
                v-if="isDev"
                @requisito-editado="getRequisitos"
                @rascunho-salvo="getRequisitos"
                :tipo-b="true"
                :requisito="item"
                text=""
                color="green-darken-2"
                class="ml-2 ml-lg-n8"
              >
              </modal-editar-requisito>
            </v-col>
          </v-row>
        </td>
      </tr>
    </tbody>
  </v-table>
  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script scoped>
/**
 * @module TabelaReqPorProjeto
 * @desc Tabela que mostra a lista de requisitos por ID projeto.
 * @vue-data {number} [idProjeto=null] - O ID do projeto.
 * @vue-data {number} [csuID=null] - O ID do Caso de Uso.
 * @vue-data {number} [reqID=null] - O ID do Requisito.
 * @vue-data {boolean} [showDialog=false] - Indica se o
 *  diálogo deve ser exibido ou não.
 * @vue-data {Array} [requisitos=null] - A lista de requisitos.
 * @vue-data {boolean} [isLoading=false] - Loader da tela.
 * @vue-data {string} [projeto=''] - Nome do projeto.
 * @vue-data {String} [isDraft=false] - Flag que indica se apenas
 * os rascunhos devem ser listados.
 * @vue-computed {Array.<Object>} requisitosFiltrados - Lista com
 * todos os requisitos ou com apenas aqueles que estão em edição.
 */
import axios from 'axios';

import ModalCriarRequisito from '@/components/dialogs/ModalCriarRequisito.vue';
import ModalEditarRequisito from '@/components/dialogs/ModalEditarRequisito.vue';
import store from '@/store/store';
export default {
  name: 'TabelaRequisitos',
  data() {
    return {
      idProjeto: null,
      csuID: null,
      reqID: null,
      showDialog: false,
      requisitos: null,
      isLoading: false,
      projeto: '',
      isDraft: false,
    };
  },
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');
    this.csuID = this.$route.params.id;
    this.getRequisitos();
  },
  computed: {
    requisitosFiltrados() {
      if (this.isDraft) {
        return this.requisitos.filter((requisito) => requisito.rascunho);
      }

      return this.requisitos;
    },

    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
  },
  methods: {
    /**
     * Formata as strings do enum;
     */
    converterTextoParaEnum(string) {
      /// TIPO REQUISITO.
      if (string === 'Restrição funcional') {
        return 'RESTRICAO_FUNCIONAL';
      } else if (string === 'Restrição organizacional') {
        return 'RESTRICAO_ORGANIZACIONAL';
      } else if (string === 'Restrição externa') {
        return 'RESTRICAO_EXTERNA';
      } else if (string === 'Restrição qualidade') {
        return 'RESTRICAO_QUALIDADE';
      }
    },
    converterEnumParaTexto(string) {
      /// TIPO REQUISITO.
      if (string === 'RESTRICAO_FUNCIONAL') {
        return 'Restrição funcional';
      } else if (string === 'RESTRICAO_ORGANIZACIONAL') {
        return 'Restrição organizacional';
      } else if (string === 'RESTRICAO_EXTERNA') {
        return 'Restrição externa';
      } else if (string === 'RESTRICAO_QUALIDADE') {
        return 'Restrição qualidade';
      }
    },
    /**
     * Método assíncrono para obter os requisitos do projeto.
     */
    async getRequisitos() {
      this.isLoading = true;
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/requisitos/projeto/${this.idProjeto}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.requisitos = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Formata uma string contendo palavras separadas por underscore (_)
     * para uma string em que as palavras começam com letra maiúscula
     * e o restante das letras são minúsculas
     * e as palavras são separadas por espaço
     *
     * @param {string} string - A string a ser formatada
     * @returns {string} A string formatada
     */
    formatarString(string) {
      const palavras = string.split('_');
      const iniciaisMaiusculas = palavras
        .map(
          (palavra) =>
            palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase(),
        )
        .join(' ');

      return iniciaisMaiusculas;
    },
  },

  components: { ModalCriarRequisito, ModalEditarRequisito },
};
</script>

<style scoped>
.v-table {
  font-size: small;
}

.req--table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.req--table tbody tr {
  background-color: #fff;
}

.req--table a {
  text-decoration: none;
  color: black;
}
.button-config {
  background-color: #004984;
  text-transform: capitalize;
}
</style>
